import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './AdGuard.css';

const ALLOWED_PATHS = ['/', '/features', '/how-it-works', '/faqs', '/about'];

export default function AdGuard({ adSlot }) {
  const { pathname } = useLocation();
  const elRef = useRef(null);

  const hasConsent = typeof window !== 'undefined' && window.localStorage && localStorage.getItem('adConsent') === '1';
  const allowed = ALLOWED_PATHS.includes(pathname);

  useEffect(() => {
    if (!hasConsent || !allowed) return;

    try {
      if (typeof window.loadAdsScript === 'function') {
        window.loadAdsScript();
      }
    } catch (e) {}

    // wait for ads script to be available, then push an ad render call
    const t = setTimeout(() => {
      try {
        if (!elRef.current) return;
        // If Adsbygoogle is present, push to it
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) { /* ignore */ }
    }, 600);

    return () => clearTimeout(t);
  }, [hasConsent, allowed, pathname]);

  if (!hasConsent || !allowed) return null;

  return (
    <div className="adguard-container" aria-hidden="false">
      <ins
        className="adsbygoogle"
        ref={elRef}
        style={{ display: 'block' }}
        data-ad-client="ca-pub-5919019421994543"
        data-ad-slot={adSlot || ''}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
}
